import { NgModule, Optional, SkipSelf } from '@angular/core';
import { NZ_CONFIG } from 'ng-zorro-antd/core/config';

@NgModule({
  providers: [
    {
      provide: NZ_CONFIG,
      useValue: {
        datePicker: { nzSuffixIcon: 'images:calendar-alt' },
        select: { nzSuffixIcon: 'images:droparrow' },
        typography: { nzCopyIcons: ['images:copy-icon-sm', 'images:copy-icon-active-sm'] }
      }
    }
  ]
})
export class ConfigModule {
  constructor(@Optional() @SkipSelf() parentModule: ConfigModule) {
    if (parentModule) {
      throw new Error('ConfigModule is already loaded, iport it only once.');
    }
  }
}
